import * as React from "react";
const SvgFiRrFlagAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flag-alt_svg__a)">
      <path
        fill="#062147"
        d="m20.358 7.5 3.237-4.297a1.99 1.99 0 0 0 .192-2.096A1.99 1.99 0 0 0 21.997 0H4C1.794 0 0 1.794 0 4v19a1 1 0 1 0 2 0v-8h19.998a1.99 1.99 0 0 0 1.79-1.107 1.99 1.99 0 0 0-.192-2.096zM2 13V4c0-1.103.897-2 2-2h17.998l-3.69 4.898a1 1 0 0 0 0 1.203l3.69 4.898z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flag-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlagAlt;
